import { DataLayer, priceVatCalc, calcPrice } from "@grandvisionhq/analytics";
const getVariantSpecification = (specificationNames, variant) => {
  for (const name of specificationNames) {
    const spec = variant.specifications.find((spec2) => spec2.specificationAttribute === name);
    if (spec) {
      return spec.value.toString().toLowerCase();
    }
  }
  return "";
};
const getSharedProductDetailEventTrackingAttributes = ({
  activeVariant,
  product,
  displayPrice,
  purchaseType,
  lineItemType
}) => {
  const {
    DataLayerTypes: { Stock, BrandType, LineItemType }
  } = DataLayer;
  const originalPrice = displayPrice.originalPrice;
  const discountedPrice = displayPrice.discountedPrice;
  let metric142 = "";
  const vatRate = product.analyticsData.vatRate;
  if (vatRate) {
    const { vatAmount } = discountedPrice ? priceVatCalc(discountedPrice, vatRate) : priceVatCalc(originalPrice, vatRate);
    metric142 = calcPrice(vatAmount, false);
  }
  const price = discountedPrice || originalPrice || void 0;
  const previousPrice = originalPrice || void 0;
  const discountedAmount = discountedPrice && originalPrice - discountedPrice || 0;
  const erpId = getVariantSpecification(["erpId"], activeVariant);
  let dimension193 = "";
  if ("isExclusiveBrand" in product) {
    const isExclusiveBrand = product.isExclusiveBrand;
    dimension193 = isExclusiveBrand ? BrandType.OwnBrand : BrandType.ExternalBrand;
  }
  const isInStock = activeVariant.stock?.stockCount > 0;
  return {
    name: activeVariant.displayName,
    id: activeVariant.sku || "",
    price: calcPrice(price, false),
    dimension143: purchaseType,
    dimension144: lineItemType || LineItemType.Single,
    dimension145: "true",
    dimension190: erpId,
    dimension193,
    dimension194: isInStock ? Stock.InStock : Stock.OutOfStock,
    metric140: calcPrice(previousPrice, false),
    metric141: calcPrice(discountedAmount, false),
    metric142
  };
};
export {
  getSharedProductDetailEventTrackingAttributes,
  getVariantSpecification
};
//# sourceMappingURL=get-shared-product-detail-event-tracking-attributes.js.map
